export const UPLOAD_IMAGE_START = 'UPLOAD_IMAGE_START';
export const UPLOAD_IMAGE_SUCCESS = 'UPLOAD_IMAGE_SUCCESS';
export const UPLOAD_IMAGE_FAILED = 'UPLOAD_IMAGE_FAILED';

export const REMOVE_UPLOADED_IMAGE = 'REMOVE_UPLOADED_IMAGE';

export const SAVE_REQUEST_SKU_EMAIL_DATA_START = 'SAVE_REQUEST_SKU_EMAIL_DATA_START';
export const SAVE_REQUEST_SKU_EMAIL_DATA_SUCCESS = 'SAVE_REQUEST_SKU_EMAIL_DATA_SUCCESS';
export const SAVE_REQUEST_SKU_EMAIL_DATA_FAILED = 'SAVE_REQUEST_SKU_EMAIL_DATA_FAILED';

export const SAVE_REQUEST_PROMOTION_EMAIL_DATA_START = 'SAVE_REQUEST_PROMOTION_EMAIL_DATA_START';
export const SAVE_REQUEST_PROMOTION_EMAIL_DATA_SUCCESS = 'SAVE_REQUEST_PROMOTION_EMAIL_DATA_SUCCESS';
export const SAVE_REQUEST_PROMOTION_EMAIL_DATA_FAILED = 'SAVE_REQUEST_PROMOTION_EMAIL_DATA_FAILED';

export const SAVE_DATA_MAPPING_REQUEST_SKU_EMAIL_DATA_START = 'SAVE_DATA_MAPPING_REQUEST_SKU_EMAIL_DATA_START';
export const SAVE_DATA_MAPPING_REQUEST_SKU_EMAIL_DATA_SUCCESS = 'SAVE_DATA_MAPPING_REQUEST_SKU_EMAIL_DATA_SUCCESS';
export const SAVE_DATA_MAPPING_REQUEST_SKU_EMAIL_DATA_FAILED = 'SAVE_DATA_MAPPING_REQUEST_SKU_EMAIL_DATA_FAILED';

export const uploadImageStart = () => ({
  type: UPLOAD_IMAGE_START
});

export const uploadImageSuccess = (data) => ({
  type: UPLOAD_IMAGE_SUCCESS,
  data
});

export const uploadImageFailed = () => ({
  type: UPLOAD_IMAGE_FAILED
});

export const removeUploadedImage = (index) => ({
  type: REMOVE_UPLOADED_IMAGE,
  index
});

export const saveRequestSkuEmailDataStart = () => ({
  type: SAVE_REQUEST_SKU_EMAIL_DATA_START
});

export const saveRequestSkuEmailDataSuccess = (data) => ({
  type: SAVE_REQUEST_SKU_EMAIL_DATA_SUCCESS,
  data
});

export const saveRequestSkuEmailDataFailed = () => ({
  type: SAVE_REQUEST_SKU_EMAIL_DATA_FAILED
});

export const saveRequestPromotionEmailDataStart = () => ({
  type: SAVE_REQUEST_PROMOTION_EMAIL_DATA_START
});

export const saveRequestPromotionEmailDataSuccess = (data) => ({
  type: SAVE_REQUEST_PROMOTION_EMAIL_DATA_SUCCESS,
  data
});

export const saveRequestPromotionEmailDataFailed = () => ({
  type: SAVE_REQUEST_PROMOTION_EMAIL_DATA_FAILED
});


export const saveDataMappingRequestSkuEmailDataStart = () => ({
  type: SAVE_DATA_MAPPING_REQUEST_SKU_EMAIL_DATA_START,
});

export const saveDataMappingRequestSkuEmailDataSuccess = (data) => ({
  type: SAVE_DATA_MAPPING_REQUEST_SKU_EMAIL_DATA_SUCCESS,
  data
});

export const saveDataMappingRequestSkuEmailDataFailed = (error) => ({
  type: SAVE_DATA_MAPPING_REQUEST_SKU_EMAIL_DATA_FAILED,
  error
});
